<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <!--<div class="time-select-picker">-->
            <!--<div class="time-select">-->
            <!--<Row :gutter="10">-->
            <!--<date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>-->
            <!--</Row>-->
            <!--</div>-->
            <!--</div>-->
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>大屏使用场景具体详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持二级编码名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--加载中-->
                <div class="demo-spin-container" v-if="isShowLoading">
                    <Spin fix></Spin>
                </div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data" v-else>
                    <Table :columns="screenDistriColumn" :data="screenDistriList"></Table>
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import dateSelect from "../../../../components/dateSelect.vue";
    import {getFuncCodeCountMap} from "../../../../service/api.js";

    export default {
        name: "screen-distri-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                startDate: this.$route.query.startDate,//上一个页面选择的开始时间
                endDate: this.$route.query.endDate,//上一个页面选择的结束时间
                schoolName: this.$route.query.schoolName,
                routerName: this.$route.query.routerName,//路由名称
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,//页面数据总数
                pageCount: 0,//页数
                isShowLoading: true,//显示加载中
                screenDistriColumn: [
                    {
                        title: "二级编码",
                        key: "func_code",
                        align: "center",
                    },
                    {
                        title: "二级编码名称",
                        key: "func_name",
                        align: "center",
                    },
                    {
                        title: "次数",
                        key: "count",
                        align: "center",
                    }
                ],
                screenDistriList: [],//数据集合
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             *  获取大屏具体使用场景详情
             */
            async getFuncCodeCountMap () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startDate,
                    endTime: _this.endDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getFuncCodeCountMap(params)
                    .then(function (data) {
                        _this.screenDistriList = data;
                        _this.isShowLoading = false;

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.isShowLoading = true;
                this.getFuncCodeCountMap();
            },
            /**
             * 搜索框
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                this.isShowLoading = true;
                this.getFuncCodeCountMap();
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: this.routerName,
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.startDate,
                        endDate: this.endDate,
                    }
                });
            }
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            this.getFuncCodeCountMap();
            //记住页面选择的开始和结束时间
            // this.$refs.dateSelect.setDate(this.selfStartDate, this.selfEndDate);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .demo-spin-container {
            display: inline-block;
            width: 100%;
            height: 500px;
            position: relative;
            border: 1px solid #eee;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>

